import { createFileRoute } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useContext, useState } from 'react'
import { z } from 'zod/v3'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { StoreCombobox } from '~/components/new/app-ui/store-combobox'
import { Title } from '~/components/new/app-ui/title'
import { withResourcePermission } from '~/components/RequireResourcePermission'
import { CameraConfigPage } from '~/components/routes/camera-config/camera-config-page'
import { Button } from '~/components/ui/button'
import { AuthContext } from '~/utils/context/auth.context'

export const Route = createFileRoute('/_authenticated/cameras/config')({
  component: withResourcePermission('stores', 'read')(RouteComponent),
  validateSearch: z.object({
    storeId: z.number().optional(),
  }),
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { storeId } = Route.useSearch()
  const { hasResourcePermission } = useContext(AuthContext)
  const [isVpnDirty, setIsVpnDirty] = useState(false)

  const canEdit = hasResourcePermission('stores', 'edit')

  const handleStoreChange = (nextStoreId: number | null) => {
    const normalizedStoreId = nextStoreId ?? undefined

    if (normalizedStoreId === storeId) {
      return
    }

    if (
      isVpnDirty &&
      !window.confirm('Des modifications VPN non enregistrées seront perdues. Continuer ?')
    ) {
      return
    }

    navigate({
      to: '/cameras/config',
      search: { storeId: normalizedStoreId },
    })
  }

  return (
    <>
      <AppHeader>
        <div className="flex w-full flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <Title>Camera Config</Title>

          <div className="flex flex-wrap items-center gap-2 lg:justify-end">
            <StoreCombobox onChange={handleStoreChange} value={storeId ?? null} />
            <Button
              variant="outline"
              onClick={() => navigate({ to: '/cameras', search: { storeId } })}
            >
              <ArrowLeft />
              Retour aux caméras
            </Button>
          </div>
        </div>
      </AppHeader>

      <AppContainer className="gap-6">
        <CameraConfigPage canEdit={canEdit} onVpnDirtyChange={setIsVpnDirty} storeId={storeId} />
      </AppContainer>
    </>
  )
}
